import React, { useState, useRef } from 'react'
import { OrderedSet } from 'immutable'
import styles from './LocationSearch.scss'
import { getCurrentUser } from 'lib/utils'
import { defineMessages } from 'react-intl'
import { commonCTAs, commonNouns, useFormatMessage } from 'lib/localization'

const R = window.Routes

const _storedHistory = window.localStorage && window.localStorage.getItem('plannerHistory')
const _currentUser = getCurrentUser()
const MAX_SUGGESTIONS = 10
const initialLocationHistory = _storedHistory ? OrderedSet(JSON.parse(_storedHistory)) : OrderedSet()
const homeLocation = _currentUser && [_currentUser.lat, _currentUser.lng].join(', ')

export const messages = defineMessages({
  enterLocation: {
    id: 'LocationSearch.enterLocation',
    defaultMessage: 'Enter a location'
  }
})

export const LocationSearch = () => {
  const fm = useFormatMessage()

  const [showLocationSuggestions, setShowLocationSuggestions] = useState(false)
  const [locationHistory, setLocationHistory] = useState(initialLocationHistory)
  const [location, setLocation] = useState('')
  const addLocationHistory = query => {
    if (query === 'Home') return
    let newHistory = locationHistory.add(query)
    if (newHistory.size > MAX_SUGGESTIONS) newHistory = OrderedSet(newHistory.toArray().slice(1, MAX_SUGGESTIONS + 1))
    window.localStorage && window.localStorage.setItem('plannerHistory', JSON.stringify(newHistory.toArray()))
    setLocationHistory(newHistory)
  }
  const removeLocationHistory = query => {
    const newHistory = locationHistory.delete(query)
    window.localStorage && window.localStorage.setItem('plannerHistory', JSON.stringify(newHistory.toArray()))
    setLocationHistory(newHistory)
  }
  const locationRef = useRef()
  const jumpToLocation = (location) => {
    if (location.trim() === '') return
    addLocationHistory(location)
    R.activeMap.gotoLocation(location === 'Home' ? homeLocation : location, true).done(() => {}).fail(() => {})
    locationRef.current.blur()
  }

  return <>
    <div className={styles.locationSearch}>
      <input
        type='text'
        value={location === 'Home' ? fm(commonNouns.home) : location}
        ref={locationRef}
        onKeyDown={e => e.keyCode === 13 && jumpToLocation(location)}
        onFocus={() => setShowLocationSuggestions(true)}
        onBlur={() => setShowLocationSuggestions(false)}
        onChange={e => setLocation(e.target.value)}
        placeholder={fm(messages.enterLocation)} />
      <button style={{ cursor: 'pointer' }} onClick={() => jumpToLocation(location)}>{fm(commonCTAs.go)}</button>
    </div>
    {showLocationSuggestions && (
      <div className={styles.locationSuggestionsContainer}>
        <div className={styles.locationSuggestions}>
          {(homeLocation ? ['Home'] : []).concat(locationHistory.toArray().reverse()).map(query => (
            <div key={query} className={styles.row} onMouseDown={e => e.preventDefault()} onClick={() => { setLocation(query); jumpToLocation(query) }}>
              <div>
                {query === 'Home' && (
                  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M8.05556 16.6666V12.2221H11.3889V16.6666H14.7778V9.99992H16.9444L9.72222 3.33325L2.5 9.99992H4.66667V16.6666H8.05556Z' fill='#9E9E9E' />
                  </svg>)}
                {query !== 'Home' && (
                  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <mask id='mask0' mask-type='alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='20' height='20'>
                      <path fill-rule='evenodd' clip-rule='evenodd' d='M0 0H20V20H0V0Z' fill='white' />
                    </mask>
                    <g mask='url(#mask0)'>
                      <path fill-rule='evenodd' clip-rule='evenodd' d='M8.15092 8.43333H2.50092V2.5L4.77592 4.84167C7.70092 1.95 12.3926 1.95 15.3176 4.84167C18.2426 7.73333 18.2176 12.4333 15.3009 15.325C12.3759 18.225 7.62592 18.225 4.70092 15.325C3.23425 13.875 2.50092 11.7333 2.50092 10.0833H4.16758C4.16758 11.7333 4.73425 13.0417 5.86758 14.1583C8.14258 16.4167 11.8259 16.4167 14.1009 14.1583C16.3759 11.9 16.3759 8.25833 14.1009 6C11.8259 3.75 8.14258 3.83333 5.86758 6.08333L8.15092 8.43333ZM10.4161 10.2083V6.66668H9.1661V10.8333L12.7328 12.95L13.3328 11.9417L10.4161 10.2083Z' fill='#9E9E9E' />
                    </g>
                  </svg>)}
                {query === 'Home' ? fm(commonNouns.home) : query}
              </div>
              {query !== 'Home' && (
                <div className={styles.remove} onClick={e => { e.stopPropagation(); removeLocationHistory(query) }}>
                  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path d='M16 5.19992L14.8001 4L10 8.80008L5.19992 4L4 5.19992L8.80008 10L4 14.8001L5.19992 16L10 11.1999L14.8001 16L16 14.8001L11.1999 10L16 5.19992Z' fill='#9E9E9E' />
                  </svg>
                </div>)}
            </div>
          ))}
        </div>
      </div>
    )}
  </>
}
